"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skipLast = void 0;
var safe_slice_1 = require("./safe-slice");
/** @internal */
var skipLast = function (array, num) {
    return (0, safe_slice_1.safeSlice)(array, 0, array.length - num);
};
exports.skipLast = skipLast;
